module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cbrDv"))).then(() => parcelRequire('2KbAe'));